module.exports = __webpack_public_path__ + "static/media/crown_s.19d4e8e9.png";